import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { useSequentialTasks } from '@wix/gg-common-lib/hooks';
import { getStoreSetupTaskGroups, resolveStoreSetupEntryMode } from './storeSetupTasks';

type Props = {
  onError: (error: Error) => void;
};

export const useStoreSetup = ({ onError }: Props) => {
  const entryMode = resolveStoreSetupEntryMode();
  const taskGroups = useMemo(() => getStoreSetupTaskGroups(entryMode), [entryMode]);
  const { runTasks } = useSequentialTasks(taskGroups);

  const { isSuccess, isError, refetch, error } = useQuery({
    queryKey: ['store-setup', entryMode],
    queryFn: async () => {
      await runTasks();
      return {};
    },
  });

  useEffect(() => {
    if (error && isError) {
      onError(error);
    }
  }, [error, isError, onError]);

  return { isSuccess, isError, refetch };
};
